import React from 'react';
import { DateTimeInput, DateTimeInputProps } from 'react-admin';

/**
 * Wrapper do DateTimeInput que corrige o problema de timezone do React-Admin v5.3.3+
 *
 * O React-Admin v5.3.3 mudou o comportamento padrão para enviar datetime local
 * em vez de UTC. Este componente restaura o comportamento anterior.
 *
 * @see https://github.com/marmelab/react-admin/issues/10375
 */
const DateTimeInputUTC: React.FC<DateTimeInputProps> = (props) => {
    return (
        <DateTimeInput
            {...props}
            parse={(value: string) => value ? new Date(value).toISOString() : null}
        />
    );
};

export default DateTimeInputUTC;
